import { render, staticRenderFns } from "./renameDialog.vue?vue&type=template&id=2d1c42e8&"
import script from "./renameDialog.vue?vue&type=script&lang=js&"
export * from "./renameDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports